"use client";

import { Button } from "@/components/ui/button";
import { Environment, PerspectiveCamera } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import dynamic from "next/dynamic";
import { Suspense } from "react";
import AnimatedBackground from "./_components/AnimatedBackground";
import Features from "./_components/Features";
import HowItWorks from "./_components/HowItWorks";

// Dynamically import the GlassesModel to prevent SSR issues
const GlassesModel = dynamic(() => import("./_components/GlassesModel"), {
	ssr: false,
	loading: () => null,
});

// Separate 3D scene component for better error handling
function Scene() {
	return (
		<Canvas>
			<PerspectiveCamera makeDefault position={[0, 0, 6]} fov={40} />
			<Environment preset="sunset" />
			<ambientLight intensity={0.5} />
			<spotLight
				position={[5, 5, 5]}
				angle={0.15}
				penumbra={1}
				intensity={1}
				castShadow
			/>
			<Suspense fallback={null}>
				<GlassesModel />
			</Suspense>
		</Canvas>
	);
}

export default function LandingPage() {
	return (
		<main className="relative min-h-screen overflow-hidden bg-black text-white">
			{/* Fixed background elements */}
			<div className="fixed inset-0">
				<AnimatedBackground />
				<Suspense fallback={null}>
					<Scene />
				</Suspense>
			</div>

			{/* Scrollable content */}
			<div className="relative mx-auto max-w-[640px]">
				{/* Hero Section */}
				<section className="flex h-screen flex-col items-center justify-center p-4 text-center">
					<div className="mx-auto max-w-full">
						<h1 className="mb-6 text-5xl font-light uppercase tracking-[0.2em]">
							CAIT <span className="font-normal">ECHO</span>
						</h1>
						<p className="mb-12 text-lg font-light tracking-wide text-gray-300">
							Enhanced Conversational Hearing Output: Visualize Your World
						</p>
						<Button
							size="lg"
							className="rounded-full border-2 border-white/20 bg-transparent px-6 py-4 text-base text-white transition-all duration-300 hover:border-white/40 hover:bg-white/10"
						>
							Learn More
						</Button>
					</div>
				</section>

				{/* Additional Sections */}
				<Features />
			</div>
			<HowItWorks />
		</main>
	);
}
